/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{7162987E-1BD9-4E8A-9CE4-F75101E17C99}",
  "sitecoreApiHost": "#SITECORE_API_HOST#",
  "jssAppName": "cert-app",
  "sitecoreInstanceUrl": "#SITECORE_INSTANCE_URL#",
  "authReturnRoot": "#AUTH_RETURN_ROOT_URL#",
  "applicationApiServiceRoot": "#APPLICATION_API#",
  "orchestrationApiServiceRoot": "#ORCHESTRATION_API#",
  "certificationApiServiceRoot": "#CERTIFICATION_API#",
  "certificationOpenApiServiceRoot": "#CERTIFICATION_OPEN_API#",
  "pageNotFoundPath": "#PAGE_NOT_FOUND_PATH#",
  "pmiWidgetCoreScript": "#PMI_WIDGET_CORE_SCRIPT#",
  "idpLivePersonScript": "#IDP_LIVE_PERSON_SCRIPT#",
  "idpAuthority": "#IDP_AUTHORITY#",
  "idpClientId": "#IDP_CLIENT_ID#",
  "livePersonAccountId": "#LIVE_PERSON_ACCOUNT_ID#",
  "defaultLanguage": "en",
  "graphQLEndpointPath": "/api/cert-app",
  "graphQLEndpoint": "#SITECORE_API_HOST#/api/cert-app?sc_apikey={7162987E-1BD9-4E8A-9CE4-F75101E17C99}"
};